import React from 'react';
import SideMenu from '../components/SideMenu';
import Header from '../components/Header';
import UserMenu from '../components/UserMenu';
import TokenRegistrationTable from '../components/TokenRegistrationTable';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Checkbox, FormControlLabel, TextField, Radio, RadioGroup, FormControl, FormLabel } from '@mui/material';

const ModifyFeeValuationBeforeReg = () => {
    return (
        <div className="flex h-screen">
            <SideMenu />
            <div className="flex-1 flex flex-col">
                <Header />
                <div className="flex flex-1">
                    {/* Left Side */}
                    <div className="flex-1 p-4">
                        <h1 className='font-semibold text-xl'>Edit Evaluation Details</h1>
                        <div className="flex">
                            <FormControlLabel
                                control={<Checkbox />}
                                label="Book No.4 2nd Party Not Present"
                            />
                            <FormControlLabel
                                control={<Checkbox />}
                                label="Book No.1 2nd Party Not Present"
                            />
                            <FormControlLabel
                                control={<Checkbox />}
                                label="Postponed Document"
                            />
                        </div>
                        <div className="flex">
                            <FormControlLabel
                                control={<Checkbox />}
                                label="Book No.1 2nd Party Not Present"
                            />
                            <FormControlLabel
                                control={<Checkbox />}
                                label="Book No.6 2nd Party Not Present"
                            />
                        </div>
                        <div>
                            <TokenRegistrationTable />
                        </div>
                    </div>

                    {/* Right Side */}
                    <div className="w-64 h-full">
                        <UserMenu />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ModifyFeeValuationBeforeReg;
